import { useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { CodeEditor, type MonacoEditor } from '../../CodeEditor';

type DynamicResponseModifiersPreviewProps = {
  response: string;
  height: number;
};

export const DynamicResponseModifiersPreview = ({
  response,
  height,
}: DynamicResponseModifiersPreviewProps) => {
  const { watch } = useFormContext();
  const modifiers = watch('dynamicResponseModifiers');

  const [codeEditorValue, setCodeEditorValue] = useState<string>(response);
  const originalResponse = useRef<string>(response);
  const editorRef = useRef<MonacoEditor>();

  const repalceResponseContent = () => {
    setCodeEditorValue(
      modifiers.reduce(
        (acc, { arguments: { match, replace } }) =>
          acc.replace(new RegExp(match, 'g'), replace),
        originalResponse.current
      )
    );
  };

  useEffect(() => {
    repalceResponseContent();
  }, [modifiers]);

  return (
    <CodeEditor
      onMount={async (editor) => {
        editorRef.current = editor;
        editorRef.current?.revealLine(1);
      }}
      value={codeEditorValue}
      options={{ readOnly: true }}
      language="json"
      height={height}
    />
  );
};
